import AbstractEntity from "../AbstractEntity";

export default class Client extends AbstractEntity {
    _id;
    _name;
    _phone1;
    _phone2;
    _email;
    _orderId;


    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getPhone1() {
        return this._phone1;
    }

    getPhone2() {
        return this._phone2;
    }

    getEmail() {
        return this._email;
    }

    getOrderId() {
        return this._orderId;
    }

    getClassName() {
        return "client";
    }
}